import { Skeleton } from '@app/components/various/Skeleton';
import { isEmpty } from '@app/utils/isEmpty';
import React from 'react';

interface Props {
  name: string;
  value: React.ReactNode;
  dataTestId?: string;
  isLoading?: boolean;
}

export const InvoiceInfoItem = ({ name, value, dataTestId, isLoading }: Props) => {
  const formattedValue = React.useMemo(() => {
    if (isLoading) {
      return <Skeleton type="text" width={50} />;
    }

    return typeof value === 'string' && isEmpty(value) ? '-' : value ?? '-';
  }, [isLoading, value]);

  return (
    <div className="body-1" data-testid={dataTestId}>
      <dt className="text-neutral-40">{name}:</dt>
      <dd className="whitespace-pre-wrap">{formattedValue}</dd>
    </div>
  );
};
